import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, of, throwError } from 'rxjs';
import { catchError, switchMap, timeout } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { authConfig } from './auth.config';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (!req.url.startsWith(authConfig.apiBaseUrl)) {
    return next(req);
  }

  return from(authService.updateToken()).pipe(
    timeout(5000),
    catchError(() => of(false)),
    switchMap(() => {
      const token = authService.token;
      if (!token) {
        return next(req);
      }

      const authorizedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next(authorizedRequest);
    }),
    catchError((error) => {
      const status = error?.status;
      if (status === 401) {
        void authService.reauthenticate();
      }
      return throwError(() => error);
    })
  );
};
